// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "crosshair-link-module--base-text-alt--global--ddf1e";
export var baseTextGlobal = "crosshair-link-module--base-text--global--a79b2";
export var blockSpacing100 = "crosshair-link-module--block-spacing-100--0cc02";
export var blockSpacing50 = "crosshair-link-module--block-spacing-50--5b92a";
export var blockVPadding100 = "crosshair-link-module--block-v-padding-100--8983f";
export var blockVPadding50 = "crosshair-link-module--block-v-padding-50--63616";
export var boldOnHover = "crosshair-link-module--boldOnHover--9dfec";
export var captionTextGlobal = "crosshair-link-module--caption-text--global--2eb91";
export var cmsRenderedContentGlobal = "crosshair-link-module--cms-rendered-content--global--6e175";
export var contentContainer = "crosshair-link-module--contentContainer--585ee";
export var crosshairs = "crosshair-link-module--crosshairs--c44dd";
export var crosshairsClosed = "crosshair-link-module--crosshairsClosed--7e150";
export var crosshairsContainer = "crosshair-link-module--crosshairsContainer--e274a";
export var crosshairsOpen = "crosshair-link-module--crosshairsOpen--87d96";
export var defaultHSpacingGlobal = "crosshair-link-module--default-h-spacing--global--543f2";
export var disabled = "crosshair-link-module--disabled--c9417";
export var fadeInAnimation = "crosshair-link-module--fadeInAnimation--11ae9";
export var fadeInOnLoadGlobal = "crosshair-link-module--fade-in-on-load--global--23033";
export var fullHeightGlobal = "crosshair-link-module--full-height--global--5b5bc";
export var fullHeightOmittingNavGlobal = "crosshair-link-module--full-height-omitting-nav--global--bae53";
export var headingTextGlobal = "crosshair-link-module--heading-text--global--49579";
export var ingressTextGlobal = "crosshair-link-module--ingress-text--global--0b9c3";
export var linkColorChangeTransitionGlobal = "crosshair-link-module--link-color-change-transition--global--ee3ce";
export var linkText = "crosshair-link-module--linkText--2dddc";
export var linkTransition = "crosshair-link-module--link-transition--f4b0e";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "crosshair-link-module--page-heading-text--global--743cb";
export var paragraphTextGlobal = "crosshair-link-module--paragraph-text--global--0ab73";
export var subheadingTextGlobal = "crosshair-link-module--subheading-text--global--5593c";
export var white = "crosshair-link-module--white--9be4a";